export default __webpack_public_path__ + "static/media/utr.6ce47de4.woff";